import React, { FC, HTMLProps, useState } from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
  image: string;
  name: string;
  username: string;
} & HTMLProps<HTMLDivElement>;
const Photo: FC<Props> = ({ image, name, username, ...props }) => {
  const [isShow, setIsShow] = useState(false);
  const { t } = useTranslation();
  const translation = t('page_editor.image.image_template');

  const [beforeName, afterName] = translation.split('{name}');
  const [beforeUnsplash, afterUnsplash] = afterName.split('{unsplash}');
  return (
    <div
      css={(theme) => ({
        cursor: 'pointer',
        position: 'relative',
        '-webkit-user-drag': 'element',
      })}
      {...props}
      onMouseOut={() => setIsShow(false)}
      onMouseOver={() => setIsShow(true)}
    >
      <img
        css={(theme) => ({
          width: '100%',
        })}
        loading="lazy"
        src={image}
      />
      <p
        css={(theme) => ({
          position: 'absolute',
          bottom: 0,
          fontSize: 10,
          left: 0,
          right: 0,
          color: '#fff',
          textAlign: 'center',
          paddingTop: 12,
          paddingBottom: 2,
          paddingLeft: 4,
          paddingRight: 4,
          background:
            'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.2) 80%, rgba(0, 0, 0, 0) 100%)',
          display: isShow ? 'block' : 'none',
        })}
      >
        {beforeName}
        <a
          css={(theme) => ({ color: theme.colors.primary })}
          href={`https://pexels.com/${username}?utm_source=twibbonize&utm_medium=referral`}
          rel="noreferrer"
          target="_blank"
        >
          {name}
        </a>
        <br />
        {beforeUnsplash}
        <a
          href={`https://pexels.com/${username}?utm_source=twibbonize&utm_medium=referral`}
          rel="noreferrer"
          target="_blank"
        >
          <img
            src="/pexels-white.svg"
            className="h-3 inline ml-1"
            alt="pexels"
          />
        </a>
      </p>
    </div>
  );
};

export default Photo;
